export type UpcomingDealDisplay =
  | {
      type: "percent"
      percent: number
      badgeLabel: string
      fullLabel: string
    }
  | {
      type: "price"
      price: number
    }
  | {
      type: "none"
    }

export interface ResolveUpcomingDealParams {
  discountPercent?: number | null
  futurePrice?: number | null
  originalPrice?: number | null
}

/**
 * Resolves whether an upcoming flash sale should display as percentage discount
 * or fixed price discount. Per user requirement, the UI displays EITHER % OR price,
 * never both together:
 * - If flash sale has a percent discount (> 0): display percent (e.g., "-15%" or "Giảm 15%").
 * - If flash sale has a fixed price discount: display price (e.g., "233.750₫").
 */
export function resolveUpcomingDealDisplay({
  discountPercent,
  futurePrice,
  originalPrice
}: ResolveUpcomingDealParams): UpcomingDealDisplay {
  const percentNum = Number(discountPercent)
  const isPercent =
    Number.isFinite(percentNum) && percentNum > 0 && percentNum <= 100

  if (isPercent) {
    const rounded = Math.round(percentNum)
    return {
      type: "percent",
      percent: rounded,
      badgeLabel: `-${rounded}%`,
      fullLabel: `Giảm ${rounded}%`
    }
  }

  const futureNum = Number(futurePrice)
  const originalNum = Number(originalPrice)
  const isPrice =
    Number.isFinite(futureNum) &&
    futureNum > 0 &&
    Number.isFinite(originalNum) &&
    originalNum > 0 &&
    futureNum < originalNum

  if (isPrice) {
    return {
      type: "price",
      price: futureNum
    }
  }

  return { type: "none" }
}

